import { FC } from "react";

import { useJuneSoComponentContext } from "@stadium/services/june-analytics";

import { ExternalButton, InternalButton } from "@sharedComponents/buttons";

import Multimedia from "@sharedComponents/multimedia";

import styles from "./main.module.scss";

type OfferingTileProps = {
  title: string;
  img: string;
  optionClassName: ModularStyles;
  learnMoreLink?: string;
  getStartedLink?: string;
};

const OfferingTile: FC<OfferingTileProps> = ({
  title: offeringTitle,
  img,
  optionClassName,
  learnMoreLink,
  getStartedLink,
}) => {
  const { componentName } = useJuneSoComponentContext();
  const formattedComponentName = componentName ? `${componentName}-offerings-section` : "";

  const renderHoveredContent = () => (
    <div className={`${styles.buttonContainer} ${styles.hoverTile}`}>
      {getStartedLink && (
        <ExternalButton
          className={styles.getStartedBtn}
          href={getStartedLink}
          prefetch={false}
          styleType="primary-outline"
          analytics={{
            componentName: formattedComponentName,
            target: "get-started",
          }}
        >
          GET STARTED
        </ExternalButton>
      )}

      {learnMoreLink && (
        <ExternalButton
          href={learnMoreLink}
          styleType="link"
          target="_blank"
          className={styles.learnMoreLink}
          prefetch={false}
          analytics={{
            componentName: formattedComponentName,
            target: "learn-more",
          }}
        >
          Learn More
        </ExternalButton>
      )}
      {!getStartedLink && !learnMoreLink && (
        <InternalButton styleType="primary-outline" className={styles.disabledBtn} disabled>
          COMING SOON
        </InternalButton>
      )}
    </div>
  );

  const renderNonHoveredContent = () => (
    <div className={`${styles.offeringImgSection} ${styles.viewTile}`}>
      <Multimedia type="image" src={img} alt={offeringTitle} className={styles.offeringImg} />
    </div>
  );
  return (
    <div className={styles.offeringContainer}>
      <div className={`${styles.offeringTiles} ${optionClassName} `} aria-label={offeringTitle}>
        <h4 className={styles.offeringTitle}>{offeringTitle}</h4>
        {renderNonHoveredContent()}
        {renderHoveredContent()}
      </div>
    </div>
  );
};

export default OfferingTile;
